import { AccountModel } from '@models';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

export interface InMemoryStorageState {
  userId: number | null;
  setUserId: (userId: number) => void;

  accountMe: AccountModel;
  setAccountMe: (accountMe: AccountModel) => void;
}

const useInMemoryStorage = createWithEqualityFn<InMemoryStorageState>()(
  (set, get) => ({
    userId: null,
    setUserId: (userId: number) => set({ userId }),

    accountMe: null,
    setAccountMe: (accountMe: AccountModel) => set({ accountMe })
  }),
  shallow
);

export { useInMemoryStorage };
